import { render, staticRenderFns } from "./notcie_system.vue?vue&type=template&id=cb38e77c&scoped=true"
import script from "./notcie_system.vue?vue&type=script&lang=js"
export * from "./notcie_system.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb38e77c",
  null
  
)

export default component.exports